export const appInterceptor = (isAppsFlag = false, action = '') => {
  if (isAppsFlag === 'true') {
    const {
      type: actionType = '',
      data = '',
      clicked = '',
      value = '',
      tab = '',
      sizeName = '',
      productCode = '',
      stockLevel = '',
      originalPrice = '',
      discountPrice = '',
      brandName = '',
      productName = '',
      recommendationsLength,
      past_recommended_size,
      howToMeasureInViewPort = '',
      isImageInViewPort = '',
      sizeGuideImageType = '',
      totalColumnInSizeChart
    } = action || {};
    const androidFuncAvaStatus = typeof GamificationAndroidJSBridge || '';
    const { webkit: { messageHandlers = '' } = {} } = window;
    try {
      switch (actionType) {
        case 'EXIT_GAME':
          androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.exitGame() : '';
          messageHandlers ? messageHandlers.exitGame.postMessage(data) : '';
          break;
        case 'REDIRECT_TO_MYREWARDS_PAGE':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.openMyRewards(data)
            : '';
          messageHandlers ? messageHandlers.openMyRewards.postMessage(data) : '';
          break;
        case 'VIEW_APPLICABLE_PRODUCTS':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.viewApplicableProducts(data)
            : '';
          messageHandlers ? messageHandlers.viewApplicableProducts.postMessage(data) : '';
          break;
        case 'VIEW_TERMS_AND_CONDITIONS':
          androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.viewTC(data) : '';
          messageHandlers ? messageHandlers.viewTC.postMessage(data) : '';
          break;
        case 'OPEN_HOME_PAGE':
          androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.openHomePage() : '';
          messageHandlers ? messageHandlers.openHomePage.postMessage('') : '';
          break;
        case 'OPEN_AJIO_WALLET_PAGE':
          androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.openAjioWallet() : '';
          messageHandlers ? messageHandlers.openAjioWallet.postMessage('') : '';
          break;
        case 'COPY_COUPON_CODE':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.copyCouponCode(data)
            : '';
          messageHandlers ? messageHandlers.copyCouponCode.postMessage(data) : '';
          break;
        case 'WEB_SHARE':
          const { title = '', gameUrl = '', imageUrl = '' } = data;
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.initShare(title, gameUrl, imageUrl)
            : '';
          messageHandlers ? messageHandlers.initShare.postMessage(title, gameUrl, imageUrl) : '';
          break;
        case 'OPEN_GAME':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.openGame(JSON.stringify(data))
            : '';
          messageHandlers ? messageHandlers.openGame.postMessage(data) : '';
          break;
        case 'START_PLAYING':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.startPlaying(JSON.stringify(data))
            : '';
          messageHandlers ? messageHandlers.startPlaying.postMessage(data) : '';
          break;
        case 'GAMEZONE_LANDING_SHARE':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.gamezoneLandingShare()
            : '';
          messageHandlers ? messageHandlers.gamezoneLandingShare.postMessage(data) : '';
          break;
        case 'GAMEZONE_TNC':
          androidFuncAvaStatus !== 'undefined' ? GamificationAndroidJSBridge.openTncPage(data) : '';
          messageHandlers ? messageHandlers.openTncPage.postMessage(data) : '';
        // GA for size guide
        case 'HOW_TO_MEASURE':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(JSON.stringify({ clicked: clicked }))
            : '',
            messageHandlers
              ? messageHandlers.sizeChartInteraction.postMessage({ clicked: clicked })
              : '';
          break;
        case 'HOW_TO_MEASURE_SEEN':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({ howToMeasureInViewPort: howToMeasureInViewPort })
              )
            : '',
            messageHandlers
              ? messageHandlers.sizeChartInteraction.postMessage({
                  howToMeasureInViewPort: howToMeasureInViewPort
                })
              : '';
          break;
        case 'HOW_TO_MEASURE_IMAGE_SEEN':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({
                  isImageInViewPort: isImageInViewPort,
                  sizeGuideImageType: sizeGuideImageType
                })
              )
            : '',
            messageHandlers
              ? messageHandlers.sizeChartInteraction.postMessage({
                  isImageInViewPort: isImageInViewPort,
                  sizeGuideImageType: sizeGuideImageType
                })
              : '';
          break;
        case 'INTERNATIONAL_CONVERSATIONS':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(JSON.stringify({ clicked: clicked }))
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({ clicked: clicked })
            : '';
          break;
        case 'BRAND_COMPARISON':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({ clicked: clicked, value: value })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({ clicked: clicked, value: value })
            : '';
          break;
        case 'SIZE_GUIDE':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(JSON.stringify({ clicked: clicked }))
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({ clicked: clicked })
            : '';
          break;
        case 'GARMENT_MEASUREMENT':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({ clicked: clicked, value: value })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({ clicked: clicked, value: value })
            : '';
          break;
        case 'CUSTOMER_FEEDBACK':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({ clicked: clicked, value: value, tab: tab })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({
                clicked: clicked,
                value: value,
                tab: tab
              })
            : '';
          break;
        case 'SIZE_CHART_SIZE_CLICK':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({
                  sizeName: sizeName,
                  productCode: productCode,
                  stockLevel: stockLevel,
                  discountPrice: discountPrice,
                  originalPrice: originalPrice
                })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({
                sizeName: sizeName,
                productCode: productCode,
                stockLevel: stockLevel,
                discountPrice: discountPrice,
                originalPrice: originalPrice
              })
            : '';
          break;
        case 'SIZE_CHART_SIZE_CLICK_GA':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({
                  product_size: sizeName,
                  product_id: productCode,
                  product_name: productName,
                  product_brand: brandName
                })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({
                product_size: sizeName,
                product_id: productCode,
                product_name: productName,
                product_brand: brandName
              })
            : '';
          break;
        case 'SIZE_RECOMMEND_GA':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({
                  total_past_recommended_products: recommendationsLength,
                  past_recommended_size: past_recommended_size
                })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({
                total_past_recommended_products: recommendationsLength,
                past_recommended_size: past_recommended_size
              })
            : '';
          break;
        case 'SIZE_CHART_VISIBILITY':
          androidFuncAvaStatus !== 'undefined'
            ? GamificationAndroidJSBridge.sizeChartInteraction(
                JSON.stringify({ totalColumnInSizeChart: totalColumnInSizeChart })
              )
            : '';
          messageHandlers
            ? messageHandlers.sizeChartInteraction.postMessage({
                totalColumnInSizeChart: totalColumnInSizeChart
              })
            : '';
          break;
        default:
          break; // do nothing
      }
    } catch (e) {
      console.log('App intcptr caught error');
    }
  }
};
